import { CmsObjectWithDefault } from '@components/Cms/types';

export type LoginFormCmsKey =
    | 'yourUsernameOrPasswordIsIncorrect'
    | 'technicalDifficulty'
    | 'youAreSuccessfullyLoggedIn'
    | 'youAreNotAllowedToLogIn'
    | 'emailLoginTabLabel'
    | 'mobileLoginTabLabel'
    | 'yourMobileNumberOrPasswordIsIncorrect'
    | 'pleaseTryAgain'
    | 'invalidOtpCode'
    | 'phoneAlreadyExist'
    | 'cantIdentifyTheUser';

export const LoginFormCmsWithDefault: CmsObjectWithDefault<LoginFormCmsKey> = {
    yourUsernameOrPasswordIsIncorrect: {
        cmsId: 67548,
        defaultTranslation: 'Email or Password is incorrect.',
    },
    yourMobileNumberOrPasswordIsIncorrect: {
        cmsId: 82027,
        defaultTranslation: 'Your mobile number or password is incorrect.',
    },
    technicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    youAreSuccessfullyLoggedIn: {
        cmsId: 115055,
        defaultTranslation: 'You are successfully logged in.',
    },
    youAreNotAllowedToLogIn: {
        cmsId: 115056,
        defaultTranslation: 'You are not allowed to log in.',
    },
    emailLoginTabLabel: {
        cmsId: 79404,
        defaultTranslation: 'EMAIL',
    },
    mobileLoginTabLabel: {
        cmsId: 79403,
        defaultTranslation: 'MOBILE',
    },
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    invalidOtpCode: {
        cmsId: 97933,
        defaultTranslation: 'The OTP code is incorrect. Please re-enter or request a new OTP.',
    },
    phoneAlreadyExist: {
        cmsId: 83203,
        defaultTranslation: 'Please use another mobile number.',
    },
    cantIdentifyTheUser: {
        cmsId: 82600,
        defaultTranslation: "Sorry, we weren't able to identify you given the information provided.",
    },
};
